<template>
  <div class="device-certificate">
    <device-qrcode class="my-qrcode" :serialNumber="data.serialNumber" hideBottom :size="100"></device-qrcode>

    <span class="title-span">{{data.extendedAttributes.find(item=>item.key==='certificate-productDescription').value}}</span>
    <span class="title-span">{{data.extendedAttributes.find(item=>item.key==='certificate-licenceDescription').value}}</span>

    <div class="field-container">
      <span class="field-span">串号：{{data.serialNumber}}</span>
      <span class="field-span">授权码：{{data.authorizationCode}}</span>
    </div>

    <div class="table-container">
      <a-table
        :columns="columns"
        :dataSource="data.functions.filter(item => item.enabled)"
        size="small"
        :pagination="false"
        :rowKey="record => record.functionId"
      >
        <template #startTime="text">
          <span>{{text?moment(text).format('YYYY-MM-DD'):'1970-01-01'}}</span>
        </template>

        <template #endTime="text">
          <span>{{text?moment(text).format('YYYY-MM-DD'):'永久'}}</span>
        </template>
      </a-table>
    </div>

    <a-divider class="divider" dashed />

    <span class="notice-span">请妥善保管好此证书，以便作为获得售后服务，技术支持和升级服务的必要证明。</span>

    <div class="tail-container">
      <div class="tail-wrapper">
        <span
          class="tail-span"
        >{{data.extendedAttributes.find(item=>item.key==='certificate-companyDescription').value}}</span>
        <span class="tail-span">日期：{{data.modifyTime | timeFormat2}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

const columns = [
  {
    title: '授权功能名称',
    dataIndex: 'name'
  },
  {
    title: '授权开始时间',
    dataIndex: 'startTime',
    scopedSlots: { customRender: 'startTime' }
  },
  {
    title: '授权结束时间',
    dataIndex: 'endTime',
    scopedSlots: { customRender: 'endTime' }
  }
]

export default {
  name: 'device-certificate',

  props: ['data'],

  data() {
    return {
      columns
    }
  },

  methods: {
    moment
  }
}
</script>

<style scoped lang="less">
.device-certificate {
  width: 900px;
  border: 1px black solid;
  padding: 24px;
  font-size: 14px;
  color: #000;
  box-sizing: border-box;
  position: relative;
  .title-span {
    font-size: 20px;
    display: block;
    font-weight: bold;
    text-align: center;
  }

  .field-container {
    margin-top: 24px;
    .field-span {
      display: block;
      margin-bottom: 8px;
    }
  }

  .table-container {
    margin-top: 24px;
    margin-bottom: 32px;
  }

  .divider {
    margin: 0px;
    border-color: black;
  }

  .notice-span {
    display: block;
    font-weight: bold;
    margin: 24px 0px;
    margin-top: 100px;
  }

  .tail-container {
    display: flex;
    justify-content: flex-end;
    font-size: 20px;
    .tail-wrapper {
      display: inline-block;
      .tail-span {
        display: block;
        font-weight: bold;
        text-align: center;
      }
    }
  }

  .my-qrcode {
    position: absolute;
    right: 24px;
    top: 24px;
  }
}
</style>
